import store from "@redux/store";
import { MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS, MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS_AND_SEARCH, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_ERROR, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_HIDE_ERROR, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_START_LOADER, MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_STOP_LOADER, MUTUAL_FUNDS_SIP_STP_SWP_UPDATE_FILTERS, } from "../interface/IMutualFundsSIP_STP_SWP_Transactions";
var MutualFundSIP_STP_SWP_TransactionsActions = /** @class */ (function () {
    function MutualFundSIP_STP_SWP_TransactionsActions() {
        this.dispatch = store.dispatch;
    }
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.getMutualFundSummaryTransactions = function (SIP_STP_SWP_TransactionsData) {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS,
            payload: { SIP_STP_SWP_TransactionsData: SIP_STP_SWP_TransactionsData },
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.startMutualFundSIP_STP_SWP_TransactionsTableShimmer = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_START_LOADER,
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.stopMutualFundSIP_STP_SWP_TransactionsTableShimmer = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_TABLE_STOP_LOADER,
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_ERROR,
            payload: { errorData: payload },
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_TRANSACTIONS_HIDE_ERROR,
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.updateAppliedFilters = function (appliedFilters) {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_UPDATE_FILTERS,
            payload: { appliedFilters: appliedFilters },
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.clearAllFilters = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS,
        });
    };
    MutualFundSIP_STP_SWP_TransactionsActions.prototype.resetSIP_STP_SWP_TransactionsFiltersAndSearch = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SIP_STP_SWP_CLEAR_ALL_FILTERS_AND_SEARCH,
        });
    };
    return MutualFundSIP_STP_SWP_TransactionsActions;
}());
export default MutualFundSIP_STP_SWP_TransactionsActions;
